import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
var listStyles = css({
  paddingLeft: "var(--ds-space-250, 20px)",
  paddingInlineStart: "var(--ds-space-250, 20px)"
});
var UList = function UList(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return jsx("ul", _extends({
    css: listStyles
  }, props), children);
};
export default UList;